import { render, staticRenderFns } from "./title-card.vue?vue&type=template&id=28bd5072&scoped=true"
import script from "./title-card.vue?vue&type=script&lang=js"
export * from "./title-card.vue?vue&type=script&lang=js"
import style0 from "./title-card.vue?vue&type=style&index=0&id=28bd5072&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bd5072",
  null
  
)

export default component.exports